module.exports = __webpack_public_path__ + "static/media/amusement(6).f96b3115.PNG";